import * as api from './api'
import { localStorage } from '@entrata/utils'
import { default as normalizeProperties } from './normalize-properties'
import { default as normalizeContractProperties } from './normalize-contract'
import { default as normalizeTenantProperties } from './normalize-tenant-properties'

export default {
  ...api,
  local: localStorage,
  normalizeProperties,
  normalizeContractProperties,
  normalizeTenantProperties,
}
